import { CreateSimpleCacheOptions, SimpleCache } from './create-simple-cache';

export type CacheFactory<T> = (opts: CreateSimpleCacheOptions<T>) => SimpleCache<T>;

export interface CacheToken<T> {
    (): void; // sentinel function (never called)
    __defaultFactory?: CacheFactory<T>;
    toString: () => string;
}

/**
 * Create a CacheToken for DI with an optional default factory.
 * @param name
 * @param defaultFactory
 */
export function createCacheToken<T>(
    name: string,
    defaultFactory?: CacheFactory<T>
): CacheToken<T> {
    const key = function() { /* sentinel */ } as CacheToken<T>;
    key.toString = () => name;
    if(defaultFactory) key.__defaultFactory = defaultFactory;
    return key;
}
